import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import styled from 'styled-components';

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: { padding: '12px', maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP }
  }
};

function sortValues(options: string[], values: string[]): string[] {
  const priorityMap = new Map<string, number>();
  options.forEach((option, index) => {
    priorityMap.set(option, index);
  });

  return values.sort((a, b) => {
    const priorityA = priorityMap.get(a) ?? Infinity;
    const priorityB = priorityMap.get(b) ?? Infinity;
    return priorityA - priorityB;
  });
}

interface IProps {
  selectedValues: string[];
  elementName: string;
  options: string[];
  handleChange: (values: string[], child: React.ReactNode) => void;
  label?: string;
  isError?: boolean;
}

export const MultipleSelect: React.FC<IProps> = ({
  selectedValues,
  handleChange,
  options,
  elementName,
  label,
  isError
}) => {
  return (
    <SelectStyled>
      <FormControl variant="outlined" sx={{ marginTop: 1, width: '100%' }} size="small" error={isError}>
        <InputLabel id={elementName}>{label}</InputLabel>
        <Select
          fullWidth
          labelId={elementName}
          id={elementName}
          multiple
          value={selectedValues}
          onChange={e => {
            const values = Array.isArray(e.target.value) ? e.target.value : [e.target.value];
            handleChange(values, sortValues(options, values));
          }}
          input={<OutlinedInput label={label} />}
          label={label}
          renderValue={selected => selected.join(', ')}
          MenuProps={MenuProps}
          sx={{
            '.MuiSelect-select': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }}
        >
          {options.map(name => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={selectedValues.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </SelectStyled>
  );
};

export const SelectStyled = styled(FormControl)`
  position: relative;
  width: 100%;
  max-width: 490px;

  div {
    width: 100%;
  }
  fieldset {
    width: 100%;
  }
  input {
    width: 100%;
  }
`;
